import React, { CSSProperties, FC, useEffect, useState } from 'react'
import { Icon, IconType, ListItem, HeaderSection } from '@lmc/ui-kit'
import { connect } from 'react-redux'
import Operations from '../../../../operations'
import { history } from '../../../../store'
import { useTranslation } from 'react-i18next'
import colors, { sizes } from '@lmc/common/constants'
import { withRouter } from '../../../../withRouter'
import { AboutMe, Carer, Resident } from '@lmc/ts-common'
import { Spinner } from '../../../../components/generic'
import { getCarerName, getHistoryTitle } from './utils'
import { find, filter } from 'lodash'
import { AboutMeSection } from './components'
import dayjs from 'dayjs'
import { RouterProps } from '@lmc/common/types'

interface StateProps {
  aboutMeHistory: AboutMe[]
  resident: Resident
  carers: Carer[]
}

interface DispatchProps {
  fetchAboutMeHistory: (id: string) => Promise<any>
  router: RouterProps
}

type Props = StateProps & DispatchProps

export const ResidetAboutMeScreenHistory: FC<Props> = ({
  fetchAboutMeHistory,
  router,
  aboutMeHistory,
  resident,
  carers,
}) => {
  const { t } = useTranslation()

  const residentId = router.params.id

  const [aboutMeHistoryDetail, setAboutMeHistoryDetail] =
    useState<AboutMe | undefined>(undefined)

  useEffect(() => {
    fetchAboutMeHistory(residentId)
  }, [residentId])

  const styles = {
    container: {
      marginTop: 10,
      paddingBottom: 100,
      maxWidth: sizes.childScreen,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    button: {
      marginRight: 'auto',
      margin: 20,
      marginBottom: 0,
    },
    logoIcon: {
      width: 25,
      height: 25,
    },
    sectionHeader: { marginBottom: 15 },
    listSections: { marginTop: 8 },
  }

  if (!aboutMeHistory) {
    return <Spinner />
  }

  return (
    <div style={styles.container as CSSProperties}>
      {!aboutMeHistoryDetail ? (
        <div style={{ paddingTop: 1 }}>
          <HeaderSection
            title={t(`aboutMe.history`)}
            subtitle={getHistoryTitle(t(`aboutMe.whosAboutMe`), resident)}
            iconColor="#EFEEFF"
            iconContent={
              <Icon customIcon={IconType.LogoPurple} style={styles.logoIcon} />
            }
            backLink
            onClick={history.back}
          />
          {aboutMeHistory.map((section) => {
            const editor = getCarerName(section.editedBy as string, carers)
            return (
              <ListItem
                key={section.id}
                hoverRequired
                onClick={() => setAboutMeHistoryDetail(section)}
                iconContent={<div>{editor?.charAt(0)}</div>}
                titleContent={dayjs(section.editedOn).format('DD-MM-YYYY')}
                style={styles.listSections}
                subTitleContent={editor}
                state="simple"
                iconBackgroundColor={colors.darkblue}
              />
            )
          })}
        </div>
      ) : (
        <AboutMeSection
          onHistoryBack={() => setAboutMeHistoryDetail(undefined)}
          carers={carers}
          requestAboutMe={false}
          aboutMe={aboutMeHistoryDetail}
          resident={resident}
        />
      )}
    </div>
  )
}

export const mapStateToProps = (
  state: {
    data: {
      'about-me-withHistory': AboutMe[]
      carers: Carer[]
      residents: Resident[]
    }
  },
  props: { router: { params: any } }
) => {
  const {
    router: {
      params: { id },
    },
  } = props

  return {
    // @ts-ignore
    aboutMeHistory: filter(state.data['about-me'], {
      resident: id,
      isRevision: true,
    }),
    resident: find(state.data.residents, { id }),
    carers: state.data.carers,
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  fetchAboutMeHistory: (id: unknown) =>
    dispatch(
      Operations.loadList(
        'about-me',
        {
          withHistory: true,
        },
        false,
        `/api/list/residents/${id}/about-me`
      )
    ),
})

export default withRouter(
  connect<StateProps, DispatchProps, Props>(
    // @ts-ignore
    mapStateToProps,
    // @ts-ignore
    mapDispatchToProps
  )(ResidetAboutMeScreenHistory)
)
